import * as Scrivito from "scrivito";
import Slider from "react-slick";
import { EventWidgetComponent } from "../EventWidget/EventWidgetComponent";
import { NewsWidgetComponent } from "../NewsWidget/NewsWidgetComponent";
import { TextImagePanelWidgetComponent } from "../TextImagePanelWidget/TextImagePanelWidgetComponent";

Scrivito.provideComponent(
  "TeaserSliderWidget",
  Scrivito.connect(({ widget }) => {
    const Arrow = (props) => {
      const { className, style, onClick, directionDesc } = props;
      return (
        <button
          aria-label={directionDesc}
          className={className}
          style={{ ...style, display: "block" }}
          onClick={onClick}
        />
      );
    };

    const panels = widget.get("panels") || [];
    const elementCount = panels.length >= 3 ? 3 : panels.length;
    const settings = {
      slidesToShow: elementCount,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
      nextArrow: (
        <Arrow directionDesc={widget.get("nextArrow") || "Nächste Seite"} />
      ),
      prevArrow: (
        <Arrow directionDesc={widget.get("prevArrow") || "Vorherige Seite"} />
      ),
    };

    return (
      <div className="teaser-slider">
        <Slider {...settings}>
          {panels.map((panel) => (
            <div key={panel.id()} className="px-3 slider-panel">
              {panel.objClass() === "TextImagePanelWidget" && (
                <TextImagePanelWidgetComponent widget={panel} />
              )}
              {panel.objClass() === "NewsWidget" && (
                <NewsWidgetComponent widget={panel} />
              )}
              {panel.objClass() === "EventWidget" && (
                <EventWidgetComponent widget={panel} />
              )}
            </div>
          ))}
        </Slider>
      </div>
    );
  })
);
